import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-inner-header',
  templateUrl: './inner-header.component.html',
  styleUrls: ['./inner-header.component.scss'],
})
export class InnerHeaderComponent implements OnInit {
  @Input() routes: {
    route: string;
    title: string;
    icon: string;
    routeExact?: boolean;
  }[] = [];

  ngOnInit() {}
}
